import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ShapePolygon = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20 14.185v-2.369A2.997 2.997 0 0022 9c0-1.654-1.346-3-3-3a2.99 2.99 0 00-2.116.876L12.969 5.31c.01-.103.031-.204.031-.31 0-1.654-1.346-3-3-3S7 3.346 7 5c0 .762.295 1.451.765 1.981L6.091 9.212A2.977 2.977 0 005 9c-1.654 0-3 1.346-3 3s1.346 3 3 3c.159 0 .313-.023.465-.047L7.4 17.532c-.248.436-.4.932-.4 1.468 0 1.654 1.346 3 3 3a2.994 2.994 0 002.863-2.153l3.962-.792A2.987 2.987 0 0019 20c1.654 0 3-1.346 3-3a2.995 2.995 0 00-2-2.815zM19 8a1.001 1.001 0 11-1 1c0-.551.448-1 1-1zm-9-4a1.001 1.001 0 11-1 1c0-.551.448-1 1-1zm-6 8a1.001 1.001 0 111 1c-.552 0-1-.449-1-1zm6 8a1 1 0 110-2 1 1 0 010 2zm2.761-2.172A3.005 3.005 0 0010 16c-.386 0-.752.079-1.091.213l-1.674-2.231C7.705 13.451 8 12.762 8 12c0-.536-.152-1.032-.399-1.467l1.935-2.58c.152.024.305.047.464.047a2.99 2.99 0 002.116-.876l3.915 1.566c-.01.103-.031.204-.031.31 0 1.302.839 2.401 2 2.815v2.369a2.996 2.996 0 00-2 2.815c0 .061.015.117.018.177l-3.257.652zM19 18a1 1 0 110-2 1 1 0 010 2z",
    key: "k0"
  }));
});
ShapePolygon.displayName = 'ShapePolygon';
export var ShapePolygonDimensions = {
  height: 24,
  width: 24
};